module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"see_more":"查看更多"}}')
  delete Component.options._Ctor
}
